import { ofType } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { emptyArray } from 'ui-components/default-props/empty';
import { LogService } from '../../services/log-service';
import Global from '../../store/global-selectors';
import * as OrderGridHeaderActions from '../../store/orders/grid/orders.grid.header.actions';
import * as Actions from './ship-together.actions';
import * as Api from './ship-together.api';
import { proceedWithShipTogether$ } from './ship-together.observables';

export const shipSalesOrdersTogether = (action$) => {
  return action$.pipe(
    ofType(Actions.SHIP_SALES_ORDERS_TOGETHER_REQUEST),
    mergeMap(({ selectedShipmentId, selectedOrderId, shipTogetherItems: items, fulfillmentPlanIdsWithoutItems }) => {
      const { uniqueArray: shipTogetherItems } = (items || emptyArray).reduce(
        (uniqueItems, item) => {
          if (!uniqueItems.uniqueMap[item.fulfillmentPlanItemId]) {
            // oxlint-disable-next-line no-param-reassign
            uniqueItems.uniqueMap = {
              ...uniqueItems.uniqueMap,
              [item.fulfillmentPlanItemId]: item,
            };
            uniqueItems.uniqueArray.push(item);
          }
          return uniqueItems;
        },
        {
          uniqueMap: {},
          uniqueArray: [],
        },
      );

      if (!selectedShipmentId || (!shipTogetherItems.length && !fulfillmentPlanIdsWithoutItems.length)) {
        LogService.logError(new Error('Either the selectedShipmentId is null or something is wrong with the items'), {
          selectedShipmentId,
          shipTogetherItems,
          fulfillmentPlanIdsWithoutItems,
        });
      }

      return Api.combineShipTogetherSalesOrders(selectedShipmentId, shipTogetherItems, fulfillmentPlanIdsWithoutItems).pipe(
        mergeMap((response) =>
          of(Actions.shipSalesOrdersTogetherSuccess(response, selectedOrderId, shipTogetherItems, fulfillmentPlanIdsWithoutItems)),
        ),
        catchError((error) => of(Actions.shipSalesOrdersTogetherFailure(error))),
      );
    }),
  );
};

export const handleGridCombineOrdersEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(OrderGridHeaderActions.ORDER_GRID_COMBINE_ORDERS),
    mergeMap(() => {
      const state = getState();
      const selectedFulfillmentPlanIds = Global.selectSelectedOrdersIds(state) || emptyArray;
      const selectedFulfillmentPlans = Global.selectEntitiesFulfillmentPlansByIds(state, {
        fulfillmentPlanIds: selectedFulfillmentPlanIds,
      });
      const salesOrders = Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, { fulfillmentPlanIds: selectedFulfillmentPlanIds });

      return proceedWithShipTogether$(action$, selectedFulfillmentPlans, salesOrders);
    }),
  );
};
